import Vue from "vue";
import Vuetify from "vuetify/lib";
// import "@mdi/font/css/materialdesignicons.css";
import {
  mdiInformation,
  mdiMessage,
  mdiVideoVintage,
  mdiPlus,
  mdiVideoOutline,
  mdiCheck,
  mdiAccount,
  mdiCancel,
  mdiDelete,
  mdiCheckboxBlankOutline,
  mdiBookOpenOutline,
  mdiCart,
  mdiLogout,
  mdiMenu,
  mdiMagnify,
  mdiAlertCircleOutline,
  mdiCursorPointer,
  mdiAccountPlus,
  mdiCheckBold,
  mdiCash,
  mdiLockQuestion,
  mdiLogin,
} from "@mdi/js";
import "vuetify/dist/vuetify.min.css";
Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    values: {
      information: mdiInformation,
      message: mdiMessage,
      videoVintage: mdiVideoVintage,
      plus: mdiPlus,
      videoOutline: mdiVideoOutline,
      check: mdiCheck,
      account: mdiAccount,
      cancel: mdiCancel,
      cursorPointer: mdiCursorPointer,
      accountPlus: mdiAccountPlus,
      checkBold: mdiCheckBold,
      cash: mdiCash,
      lockQuestion: mdiLockQuestion,
      login: mdiLogin,
      delete: mdiDelete,
      bookOpenOutline: mdiBookOpenOutline,
      cart: mdiCart,
      logout: mdiLogout,
      menu: mdiMenu,
      magnify: mdiMagnify,
      alertCircleOutline: mdiAlertCircleOutline,
      mdiCheck: mdiCheckboxBlankOutline,
    },
  },
});
